// ===== بيانات الجمعية =====
export const ORG = {
  name: "جمعية الدعوة والإرشاد وتوعية الجاليات بشمال بريدة",
  shortName: "دعوة شمال بريدة",
  code: "BNR",
  website: "bnr.org.sa",
  phone: "06XXXXXXXX",
  mobile: "05XXXXXXXX",
  email: "info@bnr.org.sa",
  location: "شمال بريدة — القصيم — السعودية",
  founded: "14XXهـ",
  regNumber: "XXXX",
};

// ===== الألوان =====
export const C = {
  primary: "#003d58",
  accent: "#dcc160",
  teal: "#00b4a2",
  bg: "#fafbfc",
  bgAlt: "#fafafa",
  sidebar: "#0A2540",
  success: "#2D8B59",
  warning: "#D4A843",
  danger: "#C4513D",
  text: "#003d58",
  textLight: "#5a7b8f",
  border: "#ebebeb",
  borderLight: "#f0f0f0",
  white: "#ffffff",
};

// ===== الأدوار =====
export const ROLES = {
  exec: "exec",
  secretary: "secretary",
  system: "system",
  communities_manager: "communities_manager",
  mosques_manager: "mosques_manager",
  finance_manager: "finance_manager",
  hr_manager: "hr_manager",
  fundraising_manager: "fundraising_manager",
  comms_manager: "comms_manager",
  women_manager: "women_manager",
  volunteer_manager: "volunteer_manager",
  preacher: "preacher",
  employee: "employee",
};

export const ROLE_NAMES = {
  exec: "المسؤول التنفيذي",
  secretary: "سكرتير المدير التنفيذي",
  system: "مدير النظام",
  communities_manager: "مدير الجاليات",
  mosques_manager: "مدير المساجد",
  finance_manager: "المدير المالي",
  hr_manager: "مدير الموارد البشرية",
  fundraising_manager: "مدير تنمية الموارد",
  comms_manager: "مدير الاتصال",
  women_manager: "مديرة النسائية",
  volunteer_manager: "مدير التطوع",
  preacher: "داعية",
  employee: "موظف",
};

export const ROLE_PERMISSIONS = {
  exec: {
    modules: ["dashboard","board","communities","mosques","women","finance","donors","fundraising","hr","communications","volunteer","governance","users"],
    canEdit: false,
    canSign: true,
    adminOnly: true,
  },
  secretary: {
    modules: ["dashboard","board","communities","mosques","women","finance","donors","fundraising","hr","communications","volunteer","governance","users"],
    canEdit: true,
    canSign: false,
    adminOnly: true,
  },
  system: {
    modules: ["dashboard","board","communities","mosques","women","finance","donors","fundraising","hr","communications","volunteer","governance","users"],
    canEdit: true,
    canSign: false,
    adminOnly: true,
  },
  communities_manager: {
    modules: ["dashboard","communities"],
    canEdit: true,
    canSign: false,
    adminOnly: false,
  },
  mosques_manager: {
    modules: ["dashboard","mosques"],
    canEdit: true,
    canSign: false,
    adminOnly: false,
  },
  finance_manager: {
    modules: ["dashboard","finance","donors"],
    canEdit: true,
    canSign: false,
    adminOnly: false,
  },
  hr_manager: {
    modules: ["dashboard","hr"],
    canEdit: true,
    canSign: false,
    adminOnly: false,
  },
  fundraising_manager: {
    modules: ["dashboard","fundraising"],
    canEdit: true,
    canSign: false,
    adminOnly: false,
  },
  comms_manager: {
    modules: ["dashboard","communications"],
    canEdit: true,
    canSign: false,
    adminOnly: false,
  },
  women_manager: {
    modules: ["dashboard","women"],
    canEdit: true,
    canSign: false,
    adminOnly: false,
  },
  volunteer_manager: {
    modules: ["dashboard","volunteer"],
    canEdit: true,
    canSign: false,
    adminOnly: false,
  },
  preacher: {
    modules: ["dashboard","communities"],
    canEdit: false,
    canSign: false,
    adminOnly: false,
  },
  employee: {
    modules: ["dashboard"],
    canEdit: false,
    canSign: false,
    adminOnly: false,
  },
};

// ===== أنواع الأحداث =====
export const EVENT_TYPES = [
  { key: "sermon", label: "كلمة دعوية", duration: "5 دقائق", color: C.teal },
  { key: "lesson", label: "درس علمي", duration: "ساعة", color: C.primary },
  { key: "day", label: "يوم علمي", duration: "يوم كامل", color: C.accent },
  { key: "course", label: "دورة علمية", duration: "3 أيام+", color: C.success },
];

// ===== مراحل الأحداث =====
export const EVENT_STAGES = [
  { key: "pre_coordination", label: "تنسيق مسبق", color: "#6366f1" },
  { key: "sheikh_coordination", label: "تنسيق مشايخ", color: C.accent },
  { key: "template_prep", label: "إعداد القالب", color: C.teal },
  { key: "execution", label: "التنفيذ", color: C.success },
  { key: "report", label: "التقرير", color: C.primary },
];

// ===== أنواع المعاملات المالية =====
export const TRANSACTION_TYPES = [
  "مشتريات",
  "رواتب",
  "إيجارات",
  "صيانة",
  "طباعة ونشر",
  "نقل وتوزيع",
  "ضيافة",
  "تقنية معلومات",
  "دعاية وإعلان",
  "مكافآت",
  "أخرى",
];

// ===== حالات المعاملات =====
export const TRANSACTION_STATUSES = [
  { key: "paid", label: "مدفوع", color: C.success },
  { key: "pending", label: "معلق", color: C.accent },
  { key: "approval", label: "قيد الاعتماد", color: C.teal },
  { key: "rejected", label: "مرفوض", color: C.danger },
];

// ===== طرق الدفع =====
export const PAYMENT_METHODS = [
  "تحويل بنكي",
  "شيك",
  "نقدي",
  "بطاقة ائتمان",
  "سداد",
];

// ===== اقتباسات يومية (31 حديث/آية) =====
export const DAILY_QUOTES = [
  { text: "إِنَّمَا الأَعْمَالُ بِالنِّيَّاتِ", source: "متفق عليه" },
  { text: "خَيْرُكُمْ مَنْ تَعَلَّمَ القُرْآنَ وَعَلَّمَهُ", source: "البخاري" },
  { text: "الدَّالُّ عَلَى الخَيْرِ كَفَاعِلِهِ", source: "مسلم" },
  { text: "مَنْ دَعَا إِلَى هُدًى كَانَ لَهُ مِنَ الأَجْرِ مِثْلُ أُجُورِ مَنْ تَبِعَهُ", source: "مسلم" },
  { text: "بَلِّغُوا عَنِّي وَلَوْ آيَةً", source: "البخاري" },
  { text: "لَأَنْ يَهْدِيَ اللهُ بِكَ رَجُلاً وَاحِداً خَيْرٌ لَكَ مِنْ حُمْرِ النَّعَمِ", source: "متفق عليه" },
  { text: "ادْعُ إِلَىٰ سَبِيلِ رَبِّكَ بِالْحِكْمَةِ وَالْمَوْعِظَةِ الْحَسَنَةِ", source: "النحل: 125" },
  { text: "وَمَنْ أَحْسَنُ قَوْلًا مِّمَّن دَعَا إِلَى اللَّهِ وَعَمِلَ صَالِحًا", source: "فصلت: 33" },
  { text: "كُنتُمْ خَيْرَ أُمَّةٍ أُخْرِجَتْ لِلنَّاسِ تَأْمُرُونَ بِالْمَعْرُوفِ", source: "آل عمران: 110" },
  { text: "مَنْ سَلَكَ طَرِيقًا يَلْتَمِسُ فِيهِ عِلْمًا سَهَّلَ اللهُ لَهُ طَرِيقًا إِلَى الجَنَّةِ", source: "مسلم" },
  { text: "إِذَا مَاتَ الإِنْسَانُ انْقَطَعَ عَمَلُهُ إِلَّا مِنْ ثَلَاثٍ", source: "مسلم" },
  { text: "خَيْرُ النَّاسِ أَنْفَعُهُمْ لِلنَّاسِ", source: "الطبراني" },
  { text: "تَبَسُّمُكَ فِي وَجْهِ أَخِيكَ صَدَقَةٌ", source: "الترمذي" },
  { text: "اتَّقِ اللهَ حَيْثُمَا كُنْتَ وَأَتْبِعِ السَّيِّئَةَ الحَسَنَةَ تَمْحُهَا", source: "الترمذي" },
  { text: "مَا نَقَصَتْ صَدَقَةٌ مِنْ مَالٍ", source: "مسلم" },
  { text: "الكَلِمَةُ الطَّيِّبَةُ صَدَقَةٌ", source: "متفق عليه" },
  { text: "مَنْ كَانَ يُؤْمِنُ بِاللهِ وَاليَوْمِ الآخِرِ فَلْيَقُلْ خَيْرًا أَوْ لِيَصْمُتْ", source: "متفق عليه" },
  { text: "إِنَّ اللهَ يُحِبُّ إِذَا عَمِلَ أَحَدُكُمْ عَمَلاً أَنْ يُتْقِنَهُ", source: "البيهقي" },
  { text: "يَسِّرُوا وَلَا تُعَسِّرُوا وَبَشِّرُوا وَلَا تُنَفِّرُوا", source: "متفق عليه" },
  { text: "الرَّاحِمُونَ يَرْحَمُهُمُ الرَّحْمَنُ", source: "أبو داود" },
  { text: "أَحَبُّ الأَعْمَالِ إِلَى اللهِ أَدْوَمُهَا وَإِنْ قَلَّ", source: "متفق عليه" },
  { text: "مَنْ يُرِدِ اللهُ بِهِ خَيْرًا يُفَقِّهْهُ فِي الدِّينِ", source: "متفق عليه" },
  { text: "الدُّنْيَا مَزْرَعَةُ الآخِرَةِ", source: "أثر" },
  { text: "وَتَعَاوَنُوا عَلَى الْبِرِّ وَالتَّقْوَىٰ", source: "المائدة: 2" },
  { text: "إِنَّ اللَّهَ لَا يُغَيِّرُ مَا بِقَوْمٍ حَتَّىٰ يُغَيِّرُوا مَا بِأَنفُسِهِمْ", source: "الرعد: 11" },
  { text: "وَقُل رَّبِّ زِدْنِي عِلْمًا", source: "طه: 114" },
  { text: "فَاذْكُرُونِي أَذْكُرْكُمْ وَاشْكُرُوا لِي وَلَا تَكْفُرُونِ", source: "البقرة: 152" },
  { text: "رَبَّنَا آتِنَا فِي الدُّنْيَا حَسَنَةً وَفِي الآخِرَةِ حَسَنَةً", source: "البقرة: 201" },
  { text: "وَمَا تَوْفِيقِي إِلَّا بِاللَّهِ عَلَيْهِ تَوَكَّلْتُ وَإِلَيْهِ أُنِيبُ", source: "هود: 88" },
  { text: "إِنَّ مَعَ الْعُسْرِ يُسْرًا", source: "الشرح: 6" },
  { text: "وَاصْبِرْ فَإِنَّ اللَّهَ لَا يُضِيعُ أَجْرَ الْمُحْسِنِينَ", source: "هود: 115" },
];

export function getDailyQuote() {
  const day = new Date().getDate();
  return DAILY_QUOTES[(day - 1) % DAILY_QUOTES.length];
}

// ===== الخطة التشغيلية =====
export const OPERATIONAL_PLAN = {
  communities: {
    name: "إدارة الجاليات",
    programs: [
      { id: "c1", name: "برنامج التعريف بالإسلام", cost: 850000, description: "تعريف الجاليات بالإسلام من خلال الزيارات الميدانية والمحاضرات", goal: "الوصول لـ 5000 شخص سنوياً", indicators: ["عدد الزيارات","عدد المحاضرات","عدد المسلمين الجدد"] },
      { id: "c2", name: "برنامج تعليم المسلمين الجدد", cost: 620000, description: "تعليم أساسيات الإسلام والعبادات للمسلمين الجدد", goal: "تخريج 300 مسلم جديد متعلم", indicators: ["عدد المتخرجين","نسبة الالتزام","معدل الحضور"] },
      { id: "c3", name: "برنامج الرعاية والمتابعة", cost: 480000, description: "متابعة المسلمين الجدد ورعايتهم اجتماعياً ودينياً", goal: "متابعة 90% من المسلمين الجدد", indicators: ["نسبة المتابعة","عدد الزيارات المنزلية","حالات الاستقرار"] },
      { id: "c4", name: "برنامج الدعاة والمترجمين", cost: 1200000, description: "توفير دعاة ومترجمين بـ 9 لغات لخدمة الجاليات", goal: "تغطية كل الجاليات بدعاة متخصصين", indicators: ["عدد الدعاة","عدد اللغات","ساعات العمل الدعوي"] },
      { id: "c5", name: "برنامج الدعوة الإلكترونية", cost: 350000, description: "إنتاج محتوى دعوي رقمي متعدد اللغات", goal: "الوصول لمليون مشاهدة سنوياً", indicators: ["عدد المنشورات","المشاهدات","التفاعل"] },
      { id: "c6", name: "برنامج الكتب والمطبوعات", cost: 520000, description: "طباعة وتوزيع الكتب الشرعية بلغات متعددة", goal: "توزيع 10,000 كتاب سنوياً", indicators: ["عدد العناوين","عدد النسخ","عدد اللغات"] },
      { id: "c7", name: "برنامج المخيمات والرحلات", cost: 765300, description: "تنظيم مخيمات دعوية ورحلات عمرة للجاليات", goal: "160 رحلة عمرة + 20 مخيم", indicators: ["عدد الرحلات","عدد المستفيدين","رضا المشاركين"] },
    ],
  },
  mosques: {
    name: "إدارة الدعوة والمساجد",
    programs: [
      { id: "m1", name: "برنامج الكلمات الدعوية", cost: 85000, description: "كلمات قصيرة بعد الصلوات في المساجد", goal: "1000 كلمة سنوياً", indicators: ["عدد الكلمات","عدد المساجد","عدد الحضور"] },
      { id: "m2", name: "برنامج الدروس العلمية", cost: 120000, description: "دروس علمية منتظمة في المساجد", goal: "500 درس سنوياً", indicators: ["عدد الدروس","عدد الطلاب","نسبة الحضور"] },
      { id: "m3", name: "برنامج الأيام العلمية", cost: 95000, description: "أيام علمية مكثفة في المساجد", goal: "50 يوم علمي سنوياً", indicators: ["عدد الأيام","عدد المشاركين","التقييم"] },
      { id: "m4", name: "برنامج الدورات العلمية", cost: 117700, description: "دورات علمية مطولة (3 أيام+)", goal: "20 دورة سنوياً", indicators: ["عدد الدورات","عدد المتدربين","نسبة الإتمام"] },
    ],
  },
  women: {
    name: "الإدارة النسائية",
    programs: [
      { id: "w1", name: "البرامج التعليمية النسائية", cost: 280000, description: "حلقات تحفيظ ودروس شرعية للنساء", goal: "خدمة 500 مستفيدة", indicators: ["عدد الحلقات","عدد المستفيدات","نسبة الحفظ"] },
      { id: "w2", name: "برامج الدعوة النسائية", cost: 180000, description: "محاضرات ودورات دعوية للنساء", goal: "200 محاضرة سنوياً", indicators: ["عدد المحاضرات","عدد الحاضرات","التقييم"] },
      { id: "w3", name: "البرامج الميدانية النسائية", cost: 160000, description: "زيارات ميدانية وتوزيع مطبوعات", goal: "تغطية كل أحياء شمال بريدة", indicators: ["عدد الزيارات","المنطقة المغطاة","عدد المستفيدات"] },
      { id: "w4", name: "برنامج المسلمات الجدد", cost: 140158, description: "رعاية ومتابعة المسلمات الجدد", goal: "متابعة كل المسلمات الجدد", indicators: ["عدد المسلمات","نسبة المتابعة","حالات الاستقرار"] },
    ],
  },
  fundraising: {
    name: "تنمية الموارد المالية",
    programs: [
      { id: "f1", name: "التسويق الإلكتروني", cost: 180000, description: "حملات تسويقية رقمية لجذب التبرعات", goal: "زيادة التبرعات الإلكترونية 30%", indicators: ["عدد الحملات","المبالغ المحصلة","معدل التحويل"] },
      { id: "f2", name: "المكاتب التعريفية", cost: 150000, description: "إدارة مكاتب تعريفية في المولات والأسواق", goal: "12 مكتب تعريفي نشط", indicators: ["عدد المكاتب","الزوار","التبرعات"] },
      { id: "f3", name: "علاقات الداعمين", cost: 120000, description: "بناء علاقات مع كبار الداعمين والمحسنين", goal: "50 داعم رئيسي", indicators: ["عدد الداعمين","متوسط التبرع","معدل الاحتفاظ"] },
      { id: "f4", name: "إدارة الأوقاف", cost: 208700, description: "إدارة وتطوير الأصول الوقفية", goal: "زيادة العائد الوقفي 20%", indicators: ["عدد الأوقاف","العائد السنوي","نسبة النمو"] },
    ],
  },
  communications: {
    name: "الاتصال المؤسسي",
    programs: [
      { id: "cm1", name: "العلاقات العامة", cost: 65000, description: "إدارة العلاقات مع الجهات الحكومية والمؤسسات", goal: "20 شراكة مؤسسية", indicators: ["عدد الشراكات","الفعاليات المشتركة","التغطيات"] },
      { id: "cm2", name: "الإعلام الرقمي", cost: 85000, description: "إنتاج محتوى إعلامي رقمي", goal: "500 محتوى سنوياً", indicators: ["عدد المنشورات","المشاهدات","التفاعل"] },
      { id: "cm3", name: "التصميم والإنتاج", cost: 72500, description: "تصميم المطبوعات والمواد البصرية", goal: "300 تصميم سنوياً", indicators: ["عدد التصاميم","وقت الإنجاز","جودة التصميم"] },
      { id: "cm4", name: "إدارة الموقع الإلكتروني", cost: 70000, description: "تطوير وإدارة الموقع الرسمي", goal: "100,000 زيارة سنوياً", indicators: ["الزيارات","مدة الجلسة","معدل الارتداد"] },
    ],
  },
  volunteer: {
    name: "إدارة التطوع",
    programs: [
      { id: "v1", name: "استقطاب المتطوعين", cost: 10000, description: "حملات لاستقطاب متطوعين جدد", goal: "200 متطوع جديد سنوياً", indicators: ["عدد المتقدمين","نسبة القبول","التنوع"] },
      { id: "v2", name: "تدريب المتطوعين", cost: 12000, description: "برامج تدريبية وتأهيلية للمتطوعين", goal: "تدريب 150 متطوع", indicators: ["عدد الدورات","عدد المتدربين","التقييم"] },
      { id: "v3", name: "تكريم المتطوعين", cost: 8000, description: "حفلات تكريم وشهادات تطوع", goal: "تكريم 100 متطوع سنوياً", indicators: ["عدد المكرمين","ساعات التطوع","رضا المتطوعين"] },
    ],
  },
};

// ===== الخطة التشغيلية الجديدة (أهداف + مهام) =====
// كل قسم: { name, weight, goals: [{ id, name, weight, tasks: [{ id, title, owner, deadline, status }] }] }
// status: "not_started" | "in_progress" | "completed"
// Strategic plan — each goal has: name, description, owner, priority, startDate, endDate, weight, indicators, budget, tasks
// Each task has: title, description, owner, startDate, deadline, status (not_started|in_progress|completed|delayed), rating (optional), notes
export const STRATEGIC_PLAN = {
  board: {
    name: "مجلس الإدارة",
    goals: [
      {
        id: "bg1", name: "تطوير الحوكمة المؤسسية",
        description: "تحديث وتعزيز ممارسات الحوكمة المؤسسية ورفع جودة القرارات",
        owner: "أمين السر", priority: "high",
        startDate: "2026-01-01", endDate: "2026-12-31",
        weight: 40, budget: 80000,
        indicators: "درجة الحوكمة\nعدد اللوائح المحدّثة\nنسبة الالتزام بالاجتماعات",
        tasks: [
          { id: "bg1t1", title: "تحديث اللوائح الرئيسية", description: "مراجعة وتحديث 5 لوائح أساسية", owner: "اللجنة القانونية", startDate: "2026-01-15", deadline: "2026-06-30", status: "completed", rating: "ممتاز", notes: "تم اعتماد 5 لوائح بالإجماع" },
          { id: "bg1t2", title: "تفعيل لجنة التدقيق", description: "تشكيل لجنة تدقيق داخلي وتفعيلها", owner: "رئيس المجلس", startDate: "2026-02-01", deadline: "2026-04-15", status: "completed", rating: "جيد", notes: "" },
          { id: "bg1t3", title: "إصدار تقارير ربع سنوية", description: "تقرير حوكمة ربع سنوي للجهات", owner: "المدير التنفيذي", startDate: "2026-04-01", deadline: "2026-12-31", status: "in_progress", rating: "", notes: "تم 2 من 4" },
        ],
      },
      {
        id: "bg2", name: "تعزيز الشفافية والإفصاح",
        description: "نشر التقارير وفتح قنوات تواصل شفافة مع الأطراف ذات العلاقة",
        owner: "المدير التنفيذي", priority: "high",
        startDate: "2026-01-01", endDate: "2026-12-31",
        weight: 30, budget: 50000,
        indicators: "عدد التقارير المنشورة\nعدد الاجتماعات المفتوحة\nزيارات صفحة الإفصاح",
        tasks: [
          { id: "bg2t1", title: "نشر التقرير السنوي", description: "إعداد ونشر التقرير المالي السنوي", owner: "المدير المالي", startDate: "2026-01-01", deadline: "2026-04-30", status: "completed", rating: "ممتاز", notes: "" },
          { id: "bg2t2", title: "تحديث الموقع الإلكتروني", description: "إضافة صفحة الشفافية والإفصاح", owner: "مدير النظام", startDate: "2026-03-01", deadline: "2026-09-30", status: "in_progress", rating: "", notes: "" },
          { id: "bg2t3", title: "اجتماعات مفتوحة سنوياً", description: "تنظيم 2 اجتماع مفتوح للمستفيدين والمتبرعين", owner: "أمين السر", startDate: "2026-05-01", deadline: "2026-11-30", status: "not_started", rating: "", notes: "" },
        ],
      },
      {
        id: "bg3", name: "تفعيل اللجان الفرعية",
        description: "تنشيط لجان المجلس الفرعية وتعيين رؤسائها ومتابعة قراراتها",
        owner: "رئيس المجلس", priority: "medium",
        startDate: "2026-01-01", endDate: "2026-12-31",
        weight: 30, budget: 30000,
        indicators: "عدد اللجان النشطة\nعدد الاجتماعات الدورية\nنسبة تنفيذ القرارات",
        tasks: [
          { id: "bg3t1", title: "تعيين رؤساء اللجان", description: "تعيين رؤساء للجان الأربع الفرعية", owner: "رئيس المجلس", startDate: "2026-01-15", deadline: "2026-03-31", status: "completed", rating: "جيد", notes: "" },
          { id: "bg3t2", title: "جدولة اجتماعات دورية", description: "وضع جدول سنوي للاجتماعات الدورية", owner: "أمين السر", startDate: "2026-02-01", deadline: "2026-04-30", status: "completed", rating: "", notes: "" },
          { id: "bg3t3", title: "متابعة تنفيذ القرارات", description: "نظام متابعة تنفيذ قرارات اللجان", owner: "أمين السر", startDate: "2026-04-01", deadline: "2026-12-31", status: "in_progress", rating: "", notes: "" },
        ],
      },
    ],
  },
  communities: {
    name: "الجاليات",
    goals: [
      {
        id: "cg1", name: "زيادة عدد المستفيدين 20%",
        description: "زيادة عدد المستفيدين من برامج الجاليات بنسبة 20% خلال العام",
        owner: "مدير الجاليات", priority: "high",
        startDate: "2026-01-01", endDate: "2026-12-31",
        weight: 30, budget: 250000,
        indicators: "عدد المستفيدين الجدد\nمعدل الاحتفاظ\nعدد المراكز",
        tasks: [
          { id: "cg1t1", title: "حملة استقطاب", description: "حملة استقطاب رمضانية شاملة", owner: "مدير التسويق", startDate: "2026-02-01", deadline: "2026-04-30", status: "completed", rating: "ممتاز", notes: "" },
          { id: "cg1t2", title: "فتح مراكز جديدة", description: "افتتاح 3 مراكز خدمة جديدة", owner: "مدير المرافق", startDate: "2026-03-01", deadline: "2026-09-30", status: "in_progress", rating: "", notes: "" },
          { id: "cg1t3", title: "برامج متعددة اللغات", description: "إطلاق برامج بـ 5 لغات", owner: "مدير البرامج", startDate: "2026-04-01", deadline: "2026-08-31", status: "in_progress", rating: "", notes: "" },
          { id: "cg1t4", title: "استبيان احتياجات", description: "إجراء استبيان شامل لاحتياجات الجاليات", owner: "محلل البيانات", startDate: "2026-01-15", deadline: "2026-03-31", status: "completed", rating: "جيد", notes: "" },
        ],
      },
      {
        id: "cg2", name: "تأهيل 10 دعاة جدد",
        description: "استقطاب وتأهيل 10 دعاة جدد للعمل مع الجاليات",
        owner: "مدير الجاليات", priority: "high",
        startDate: "2026-01-01", endDate: "2026-12-31",
        weight: 25, budget: 180000,
        indicators: "عدد الدعاة المؤهلين\nعدد ساعات التدريب\nمعدل الرضا",
        tasks: [
          { id: "cg2t1", title: "برنامج تدريبي", description: "إعداد منهج تدريبي 80 ساعة", owner: "وحدة التدريب", startDate: "2026-01-15", deadline: "2026-04-30", status: "completed", rating: "ممتاز", notes: "" },
          { id: "cg2t2", title: "دورة لغات", description: "تدريب الدعاة على 3 لغات", owner: "مدرّب اللغات", startDate: "2026-05-01", deadline: "2026-09-30", status: "in_progress", rating: "", notes: "" },
          { id: "cg2t3", title: "تقييم أداء", description: "تقييم نصف سنوي للأداء", owner: "مدير الجاليات", startDate: "2026-06-30", deadline: "2026-11-30", status: "not_started", rating: "", notes: "" },
          { id: "cg2t4", title: "توزيع على المساجد", description: "توزيع الدعاة على 10 مساجد", owner: "مدير المساجد", startDate: "2026-09-30", deadline: "2026-12-31", status: "not_started", rating: "", notes: "" },
        ],
      },
      {
        id: "cg3", name: "إطلاق 5 برامج دعوية جديدة",
        description: "تصميم وإطلاق 5 برامج دعوية مبتكرة",
        owner: "مدير البرامج", priority: "medium",
        startDate: "2026-01-01", endDate: "2026-12-31",
        weight: 25, budget: 220000,
        indicators: "عدد البرامج المُطلقة\nعدد المستفيدين\nرضا المستفيدين",
        tasks: [
          { id: "cg3t1", title: "دراسة احتياجات", description: "تحليل احتياجات الجاليات", owner: "محلل البيانات", startDate: "2026-01-15", deadline: "2026-03-15", status: "completed", rating: "جيد", notes: "" },
          { id: "cg3t2", title: "تصميم البرامج", description: "تصميم 5 برامج جديدة", owner: "مدير البرامج", startDate: "2026-03-15", deadline: "2026-06-30", status: "completed", rating: "ممتاز", notes: "" },
          { id: "cg3t3", title: "تأمين الميزانية", description: "اعتماد ميزانية البرامج", owner: "المدير المالي", startDate: "2026-05-01", deadline: "2026-07-31", status: "in_progress", rating: "", notes: "" },
          { id: "cg3t4", title: "التنفيذ والمتابعة", description: "إطلاق ومتابعة البرامج", owner: "مدير الجاليات", startDate: "2026-08-01", deadline: "2026-12-31", status: "in_progress", rating: "", notes: "" },
        ],
      },
      {
        id: "cg4", name: "متابعة المسلمين الجدد",
        description: "بناء نظام متكامل لمتابعة المسلمين الجدد",
        owner: "منسق الرعاية", priority: "high",
        startDate: "2026-01-01", endDate: "2026-12-31",
        weight: 20, budget: 130000,
        indicators: "نسبة المتابعة\nعدد الحقائب المُسلَّمة\nنسبة إتمام البرامج",
        tasks: [
          { id: "cg4t1", title: "نظام متابعة", description: "تطوير نظام إلكتروني للمتابعة", owner: "مدير النظام", startDate: "2026-02-01", deadline: "2026-06-30", status: "completed", rating: "جيد", notes: "" },
          { id: "cg4t2", title: "حقيبة المسلم الجديد", description: "إعداد وتوزيع حقيبة كاملة", owner: "مدير المرافق", startDate: "2026-03-01", deadline: "2026-12-31", status: "in_progress", rating: "", notes: "" },
          { id: "cg4t3", title: "برنامج كفالة", description: "إطلاق برنامج كفالة المسلم الجديد", owner: "مدير تنمية الموارد", startDate: "2026-04-01", deadline: "2026-09-30", status: "in_progress", rating: "", notes: "" },
          { id: "cg4t4", title: "تقارير شهرية", description: "تقارير متابعة شهرية", owner: "منسق الرعاية", startDate: "2026-02-28", deadline: "2026-12-31", status: "in_progress", rating: "", notes: "" },
        ],
      },
    ],
  },
  mosques: {
    name: "المساجد",
    goals: [
      {
        id: "mg1", name: "صيانة 15 مسجد خلال العام",
        description: "إنجاز صيانة شاملة لـ 15 مسجد",
        owner: "مدير الصيانة", priority: "high",
        startDate: "2026-01-01", endDate: "2026-12-31",
        weight: 40, budget: 850000,
        indicators: "عدد المساجد المنجزة\nمعدل رضا المصلين\nالتكلفة الإجمالية",
        tasks: [
          { id: "mg1t1", title: "حصر الاحتياجات", description: "زيارة وتقييم 15 مسجد", owner: "فريق الميدان", startDate: "2026-01-01", deadline: "2026-02-28", status: "completed", rating: "ممتاز", notes: "" },
          { id: "mg1t2", title: "عروض أسعار", description: "الحصول على 3 عروض لكل مسجد", owner: "مدير المشتريات", startDate: "2026-02-15", deadline: "2026-04-15", status: "completed", rating: "جيد", notes: "" },
          { id: "mg1t3", title: "جدولة التنفيذ", description: "وضع جدول زمني للصيانة", owner: "مدير المشاريع", startDate: "2026-04-01", deadline: "2026-04-30", status: "completed", rating: "", notes: "" },
          { id: "mg1t4", title: "التنفيذ", description: "تنفيذ صيانة 15 مسجد", owner: "مدير الصيانة", startDate: "2026-05-01", deadline: "2026-11-30", status: "in_progress", rating: "", notes: "تم 8 من 15" },
          { id: "mg1t5", title: "تقييم نهائي", description: "استبيان رضا المصلين", owner: "وحدة التقييم", startDate: "2026-11-30", deadline: "2026-12-31", status: "not_started", rating: "", notes: "" },
        ],
      },
      {
        id: "mg2", name: "تعيين أئمة ومؤذنين لـ 5 مساجد",
        description: "تعيين 5 أئمة و 5 مؤذنين مؤهلين",
        owner: "مدير المساجد", priority: "high",
        startDate: "2026-01-01", endDate: "2026-09-30",
        weight: 30, budget: 250000,
        indicators: "عدد التعيينات\nمعدل الرضا\nنسبة الاحتفاظ",
        tasks: [
          { id: "mg2t1", title: "إعلان التوظيف", description: "نشر إعلانات الوظائف", owner: "الموارد البشرية", startDate: "2026-01-15", deadline: "2026-02-15", status: "completed", rating: "", notes: "" },
          { id: "mg2t2", title: "مقابلات", description: "إجراء المقابلات الشخصية", owner: "لجنة الاختيار", startDate: "2026-02-15", deadline: "2026-04-30", status: "completed", rating: "جيد", notes: "" },
          { id: "mg2t3", title: "تعيين", description: "اعتماد التعيينات", owner: "المدير التنفيذي", startDate: "2026-05-01", deadline: "2026-07-31", status: "completed", rating: "ممتاز", notes: "" },
          { id: "mg2t4", title: "تدريب", description: "تدريب الأئمة الجدد", owner: "وحدة التدريب", startDate: "2026-08-01", deadline: "2026-09-30", status: "in_progress", rating: "", notes: "" },
        ],
      },
      {
        id: "mg3", name: "برنامج النظافة الشاملة",
        description: "تنظيم برنامج نظافة دوري لجميع المساجد",
        owner: "مدير المرافق", priority: "medium",
        startDate: "2026-01-01", endDate: "2026-12-31",
        weight: 30, budget: 180000,
        indicators: "عدد المساجد المخدومة\nتكرار التنظيف\nمعدل الرضا",
        tasks: [
          { id: "mg3t1", title: "تعاقد مع شركات", description: "اختيار وتعاقد مع شركتين", owner: "مدير المشتريات", startDate: "2026-01-15", deadline: "2026-03-31", status: "completed", rating: "", notes: "" },
          { id: "mg3t2", title: "جدول أسبوعي", description: "وضع جدول نظافة أسبوعي", owner: "مدير المرافق", startDate: "2026-04-01", deadline: "2026-04-30", status: "completed", rating: "", notes: "" },
          { id: "mg3t3", title: "متابعة", description: "متابعة جودة التنفيذ", owner: "وحدة المتابعة", startDate: "2026-05-01", deadline: "2026-12-31", status: "in_progress", rating: "", notes: "" },
          { id: "mg3t4", title: "تقييم دوري", description: "تقييم شهري للأداء", owner: "وحدة التقييم", startDate: "2026-05-01", deadline: "2026-12-31", status: "in_progress", rating: "", notes: "" },
        ],
      },
    ],
  },
  women: {
    name: "النسائي",
    goals: [
      {
        id: "wg1", name: "افتتاح 5 حلقات تحفيظ جديدة",
        description: "افتتاح 5 حلقات تحفيظ للنساء في أحياء جديدة",
        owner: "مديرة القسم النسائي", priority: "high",
        startDate: "2026-01-01", endDate: "2026-10-31",
        weight: 35, budget: 220000,
        indicators: "عدد الحلقات\nعدد الطالبات\nنسبة الإنجاز",
        tasks: [
          { id: "wg1t1", title: "تأمين معلمات", description: "اختيار وتأهيل 5 معلمات", owner: "مديرة التوظيف", startDate: "2026-01-15", deadline: "2026-04-30", status: "completed", rating: "ممتاز", notes: "" },
          { id: "wg1t2", title: "تجهيز أماكن", description: "تجهيز 5 قاعات", owner: "إدارة المرافق", startDate: "2026-03-01", deadline: "2026-06-30", status: "in_progress", rating: "", notes: "تم 3 من 5" },
          { id: "wg1t3", title: "تسجيل طالبات", description: "تسجيل 150 طالبة", owner: "منسقة التسجيل", startDate: "2026-05-01", deadline: "2026-09-30", status: "in_progress", rating: "", notes: "" },
          { id: "wg1t4", title: "متابعة", description: "متابعة الأداء شهرياً", owner: "المشرفة العامة", startDate: "2026-07-01", deadline: "2026-10-31", status: "not_started", rating: "", notes: "" },
        ],
      },
      {
        id: "wg2", name: "تدريب 10 معلمات",
        description: "تأهيل 10 معلمات جديدات بمنهج معتمد",
        owner: "مديرة التدريب", priority: "high",
        startDate: "2026-01-01", endDate: "2026-11-30",
        weight: 35, budget: 150000,
        indicators: "عدد المعلمات المُدرَّبات\nنسبة النجاح\nمعدل الرضا",
        tasks: [
          { id: "wg2t1", title: "تحديد الاحتياج", description: "تحليل احتياجات التدريب", owner: "مديرة التدريب", startDate: "2026-01-15", deadline: "2026-02-28", status: "completed", rating: "جيد", notes: "" },
          { id: "wg2t2", title: "تصميم البرنامج", description: "إعداد منهج تدريبي 60 ساعة", owner: "متخصصة تربوية", startDate: "2026-03-01", deadline: "2026-05-31", status: "completed", rating: "ممتاز", notes: "" },
          { id: "wg2t3", title: "تنفيذ", description: "تدريب الدفعتين", owner: "وحدة التدريب", startDate: "2026-06-01", deadline: "2026-10-31", status: "in_progress", rating: "", notes: "" },
          { id: "wg2t4", title: "تقييم", description: "تقييم نهائي للمعلمات", owner: "اللجنة التدريبية", startDate: "2026-10-31", deadline: "2026-11-30", status: "not_started", rating: "", notes: "" },
        ],
      },
      {
        id: "wg3", name: "برنامج تربية الأبناء",
        description: "إطلاق برنامج متكامل للأمهات في التربية",
        owner: "مديرة البرامج", priority: "medium",
        startDate: "2026-01-01", endDate: "2026-12-31",
        weight: 30, budget: 140000,
        indicators: "عدد الأمهات المستفيدات\nمعدل الحضور\nقياس الأثر",
        tasks: [
          { id: "wg3t1", title: "إعداد المحتوى", description: "تطوير 12 وحدة تدريبية", owner: "متخصصة تربوية", startDate: "2026-01-15", deadline: "2026-05-31", status: "completed", rating: "ممتاز", notes: "" },
          { id: "wg3t2", title: "جدولة الدورات", description: "جدول الدورات الفصلي", owner: "منسقة البرامج", startDate: "2026-06-01", deadline: "2026-06-30", status: "completed", rating: "", notes: "" },
          { id: "wg3t3", title: "تنفيذ", description: "تنفيذ 4 دورات سنوية", owner: "مديرة البرامج", startDate: "2026-07-01", deadline: "2026-12-31", status: "in_progress", rating: "", notes: "" },
          { id: "wg3t4", title: "قياس الأثر", description: "استبيان أثر بعد كل دورة", owner: "وحدة التقييم", startDate: "2026-09-30", deadline: "2026-12-31", status: "not_started", rating: "", notes: "" },
        ],
      },
    ],
  },
  finance: {
    name: "المالية",
    goals: [
      {
        id: "fng1", name: "تطبيق نظام محاسبي متكامل",
        description: "اعتماد وتطبيق نظام ERP محاسبي متكامل",
        owner: "المدير المالي", priority: "high",
        startDate: "2026-01-01", endDate: "2026-12-31",
        weight: 40, budget: 320000,
        indicators: "نسبة التطبيق\nسرعة الإصدارات\nدقة التقارير",
        tasks: [
          { id: "fng1t1", title: "اختيار النظام", description: "تقييم 3 أنظمة واختيار الأنسب", owner: "مدير النظام", startDate: "2026-01-15", deadline: "2026-03-31", status: "completed", rating: "جيد", notes: "" },
          { id: "fng1t2", title: "تدريب", description: "تدريب 6 موظفين", owner: "وحدة التدريب", startDate: "2026-04-01", deadline: "2026-06-30", status: "completed", rating: "ممتاز", notes: "" },
          { id: "fng1t3", title: "ترحيل البيانات", description: "ترحيل بيانات السنوات السابقة", owner: "محاسب أول", startDate: "2026-06-15", deadline: "2026-09-30", status: "in_progress", rating: "", notes: "" },
          { id: "fng1t4", title: "تشغيل", description: "تشغيل النظام رسمياً", owner: "المدير المالي", startDate: "2026-10-01", deadline: "2026-12-31", status: "not_started", rating: "", notes: "" },
        ],
      },
      {
        id: "fng2", name: "إعداد الميزانية التقديرية",
        description: "إعداد ميزانية تقديرية لـ 2027",
        owner: "المدير المالي", priority: "high",
        startDate: "2026-08-01", endDate: "2026-12-31",
        weight: 35, budget: 50000,
        indicators: "اكتمال البيانات\nمعدل الالتزام بالميزانية",
        tasks: [
          { id: "fng2t1", title: "جمع بيانات الأقسام", description: "احتياجات كل قسم", owner: "محاسب أول", startDate: "2026-08-01", deadline: "2026-09-30", status: "in_progress", rating: "", notes: "" },
          { id: "fng2t2", title: "إعداد المسودة", description: "ميزانية مسودة أولى", owner: "المدير المالي", startDate: "2026-10-01", deadline: "2026-10-31", status: "not_started", rating: "", notes: "" },
          { id: "fng2t3", title: "مراجعة", description: "مراجعة مع المديرين", owner: "المدير التنفيذي", startDate: "2026-11-01", deadline: "2026-11-30", status: "not_started", rating: "", notes: "" },
          { id: "fng2t4", title: "اعتماد", description: "اعتماد المجلس", owner: "مجلس الإدارة", startDate: "2026-12-01", deadline: "2026-12-31", status: "not_started", rating: "", notes: "" },
        ],
      },
      {
        id: "fng3", name: "تحسين التحصيل",
        description: "تطبيق نظام تتبع للتحصيل وتقليل المتأخرات",
        owner: "محاسب التحصيل", priority: "medium",
        startDate: "2026-01-01", endDate: "2026-12-31",
        weight: 25, budget: 35000,
        indicators: "نسبة التحصيل\nقيمة المتأخرات",
        tasks: [
          { id: "fng3t1", title: "نظام تتبع", description: "بناء نظام تتبع للمستحقات", owner: "مدير النظام", startDate: "2026-02-01", deadline: "2026-05-31", status: "completed", rating: "", notes: "" },
          { id: "fng3t2", title: "تقارير شهرية", description: "إصدار تقرير شهري", owner: "محاسب التحصيل", startDate: "2026-06-01", deadline: "2026-12-31", status: "in_progress", rating: "", notes: "" },
          { id: "fng3t3", title: "متابعة المتأخرات", description: "تواصل مباشر مع المدينين", owner: "محاسب التحصيل", startDate: "2026-04-01", deadline: "2026-12-31", status: "in_progress", rating: "", notes: "" },
        ],
      },
    ],
  },
  donors: {
    name: "المتبرعين",
    goals: [
      {
        id: "dg1", name: "زيادة قاعدة المتبرعين 30%",
        description: "زيادة عدد المتبرعين النشطين بنسبة 30%",
        owner: "مدير تنمية الموارد", priority: "high",
        startDate: "2026-01-01", endDate: "2026-12-31",
        weight: 40, budget: 220000,
        indicators: "عدد المتبرعين الجدد\nنسبة النمو\nقيمة التبرعات",
        tasks: [
          { id: "dg1t1", title: "حملة استقطاب", description: "حملة استقطاب متبرعين جدد", owner: "مدير التسويق", startDate: "2026-01-15", deadline: "2026-08-31", status: "in_progress", rating: "", notes: "" },
          { id: "dg1t2", title: "قاعدة بيانات CRM", description: "بناء قاعدة CRM موحدة", owner: "مدير النظام", startDate: "2026-02-01", deadline: "2026-06-30", status: "completed", rating: "ممتاز", notes: "" },
          { id: "dg1t3", title: "فعاليات تعريفية", description: "تنظيم 4 فعاليات", owner: "مدير الفعاليات", startDate: "2026-04-01", deadline: "2026-11-30", status: "in_progress", rating: "", notes: "" },
          { id: "dg1t4", title: "تقارير أثر", description: "تقارير أثر دورية للمتبرعين", owner: "محلل البيانات", startDate: "2026-06-01", deadline: "2026-12-31", status: "in_progress", rating: "", notes: "" },
        ],
      },
      {
        id: "dg2", name: "تحسين نسبة الاحتفاظ بالمتبرعين",
        description: "رفع معدل احتفاظ من 60% إلى 80%",
        owner: "مدير العلاقات", priority: "high",
        startDate: "2026-01-01", endDate: "2026-12-31",
        weight: 35, budget: 120000,
        indicators: "نسبة الاحتفاظ\nمعدل الرضا\nتكرار التبرع",
        tasks: [
          { id: "dg2t1", title: "برنامج تواصل دوري", description: "SMS و Email أسبوعي/شهري", owner: "فريق التسويق", startDate: "2026-02-01", deadline: "2026-05-31", status: "completed", rating: "جيد", notes: "" },
          { id: "dg2t2", title: "تقارير شفافية", description: "تقارير شفافية ربع سنوية", owner: "المدير المالي", startDate: "2026-04-01", deadline: "2026-12-31", status: "in_progress", rating: "", notes: "" },
          { id: "dg2t3", title: "فعاليات تكريم", description: "حفل تكريم سنوي", owner: "مدير الفعاليات", startDate: "2026-10-01", deadline: "2026-11-30", status: "not_started", rating: "", notes: "" },
          { id: "dg2t4", title: "استبيان رضا", description: "استبيان رضا نصف سنوي", owner: "وحدة التقييم", startDate: "2026-06-01", deadline: "2026-12-31", status: "in_progress", rating: "", notes: "" },
        ],
      },
      {
        id: "dg3", name: "تنويع مصادر الدخل",
        description: "تأسيس مصادر دخل مستدامة جديدة",
        owner: "المدير المالي", priority: "medium",
        startDate: "2026-01-01", endDate: "2026-12-31",
        weight: 25, budget: 280000,
        indicators: "عدد المصادر الجديدة\nنسبة كل مصدر من الإيراد",
        tasks: [
          { id: "dg3t1", title: "صناديق وقفية", description: "تأسيس صندوق وقفي", owner: "المدير المالي", startDate: "2026-03-01", deadline: "2026-10-31", status: "not_started", rating: "", notes: "" },
          { id: "dg3t2", title: "استثمارات", description: "دراسة فرص استثمار", owner: "لجنة المالية", startDate: "2026-02-01", deadline: "2026-08-15", status: "in_progress", rating: "", notes: "" },
          { id: "dg3t3", title: "شراكات مؤسسية", description: "5 شراكات مؤسسية جديدة", owner: "مدير الشراكات", startDate: "2026-01-15", deadline: "2026-12-31", status: "in_progress", rating: "", notes: "" },
          { id: "dg3t4", title: "حملات رقمية", description: "حملات رقمية مدفوعة", owner: "مدير التسويق", startDate: "2026-04-01", deadline: "2026-12-31", status: "in_progress", rating: "", notes: "" },
        ],
      },
    ],
  },
  fundraising: {
    name: "تنمية الموارد",
    goals: [
      {
        id: "fg1", name: "تحصيل 3 مليون ريال",
        description: "تحقيق إيرادات بقيمة 3M ريال",
        owner: "مدير تنمية الموارد", priority: "high",
        startDate: "2026-01-01", endDate: "2026-12-31",
        weight: 45, budget: 350000,
        indicators: "إجمالي المحصّل\nنسبة كل حملة\nمتوسط التبرع",
        tasks: [
          { id: "fg1t1", title: "حملة رمضان", description: "حملة رمضان السنوية", owner: "مدير الحملات", startDate: "2026-02-01", deadline: "2026-04-30", status: "completed", rating: "ممتاز", notes: "تجاوزت المستهدف" },
          { id: "fg1t2", title: "مشاريع بناء", description: "حملات بناء مساجد", owner: "مدير المشاريع", startDate: "2026-01-01", deadline: "2026-12-31", status: "in_progress", rating: "", notes: "" },
          { id: "fg1t3", title: "كفالات", description: "كفالات دعاة وأيتام", owner: "مدير الكفالات", startDate: "2026-01-01", deadline: "2026-12-31", status: "in_progress", rating: "", notes: "" },
          { id: "fg1t4", title: "حملات رقمية", description: "حملات على المنصات", owner: "مدير التسويق", startDate: "2026-03-01", deadline: "2026-12-31", status: "in_progress", rating: "", notes: "" },
        ],
      },
      {
        id: "fg2", name: "إبرام 5 شراكات استراتيجية",
        description: "توقيع 5 اتفاقيات شراكة كبرى",
        owner: "المدير التنفيذي", priority: "high",
        startDate: "2026-01-01", endDate: "2026-11-30",
        weight: 30, budget: 50000,
        indicators: "عدد الشراكات الموقّعة\nقيمة الشراكات",
        tasks: [
          { id: "fg2t1", title: "تحديد الجهات", description: "قائمة 20 جهة محتملة", owner: "مدير العلاقات", startDate: "2026-01-15", deadline: "2026-02-28", status: "completed", rating: "", notes: "" },
          { id: "fg2t2", title: "تقديم العروض", description: "عروض مخصصة لكل جهة", owner: "مدير العلاقات", startDate: "2026-03-01", deadline: "2026-07-31", status: "in_progress", rating: "", notes: "" },
          { id: "fg2t3", title: "توقيع الاتفاقيات", description: "توقيع 5 اتفاقيات", owner: "المدير التنفيذي", startDate: "2026-05-01", deadline: "2026-11-30", status: "in_progress", rating: "", notes: "تم 3 من 5" },
          { id: "fg2t4", title: "متابعة", description: "متابعة تنفيذ الاتفاقيات", owner: "مدير العلاقات", startDate: "2026-06-01", deadline: "2026-12-31", status: "in_progress", rating: "", notes: "" },
        ],
      },
      {
        id: "fg3", name: "إطلاق منصة تبرع إلكترونية",
        description: "بناء وإطلاق منصة تبرع متكاملة",
        owner: "مدير النظام", priority: "high",
        startDate: "2026-01-01", endDate: "2026-09-30",
        weight: 25, budget: 280000,
        indicators: "اكتمال المنصة\nعدد المعاملات\nقيمة التبرعات",
        tasks: [
          { id: "fg3t1", title: "تصميم", description: "تصميم واجهة المستخدم", owner: "مدير التصميم", startDate: "2026-01-15", deadline: "2026-03-31", status: "completed", rating: "ممتاز", notes: "" },
          { id: "fg3t2", title: "تطوير", description: "تطوير المنصة", owner: "فريق التطوير", startDate: "2026-04-01", deadline: "2026-07-31", status: "in_progress", rating: "", notes: "" },
          { id: "fg3t3", title: "اختبار", description: "اختبار شامل وأمني", owner: "مدير الجودة", startDate: "2026-08-01", deadline: "2026-08-31", status: "not_started", rating: "", notes: "" },
          { id: "fg3t4", title: "إطلاق", description: "إطلاق رسمي للمنصة", owner: "المدير التنفيذي", startDate: "2026-09-01", deadline: "2026-09-30", status: "not_started", rating: "", notes: "" },
        ],
      },
    ],
  },
  hr: {
    name: "الموارد البشرية",
    goals: [
      {
        id: "hg1", name: "تدريب 100% من الموظفين",
        description: "ضمان تدريب كل موظف بدورة في تخصصه",
        owner: "مدير الموارد البشرية", priority: "high",
        startDate: "2026-01-01", endDate: "2026-12-31",
        weight: 40, budget: 280000,
        indicators: "نسبة الموظفين المدربين\nساعات التدريب\nقياس الأثر",
        tasks: [
          { id: "hg1t1", title: "تحديد الاحتياجات", description: "تحليل احتياجات كل موظف", owner: "مدير الموارد البشرية", startDate: "2026-01-15", deadline: "2026-02-28", status: "completed", rating: "", notes: "" },
          { id: "hg1t2", title: "خطة تدريب", description: "إعداد خطة تدريب سنوية", owner: "مدير التدريب", startDate: "2026-03-01", deadline: "2026-03-31", status: "completed", rating: "جيد", notes: "" },
          { id: "hg1t3", title: "تنفيذ", description: "تنفيذ الدورات", owner: "وحدة التدريب", startDate: "2026-04-01", deadline: "2026-11-30", status: "in_progress", rating: "", notes: "تم 5 من 8" },
          { id: "hg1t4", title: "تقييم", description: "قياس أثر التدريب", owner: "وحدة التقييم", startDate: "2026-11-30", deadline: "2026-12-31", status: "not_started", rating: "", notes: "" },
        ],
      },
      {
        id: "hg2", name: "تقييم أداء سنوي شامل",
        description: "تطبيق نظام تقييم أداء شامل",
        owner: "مدير الموارد البشرية", priority: "high",
        startDate: "2026-09-01", endDate: "2026-12-31",
        weight: 35, budget: 60000,
        indicators: "نسبة الإنجاز\nمتوسط درجات الأداء",
        tasks: [
          { id: "hg2t1", title: "إعداد النماذج", description: "تصميم نماذج التقييم", owner: "مدير الموارد البشرية", startDate: "2026-06-01", deadline: "2026-08-31", status: "completed", rating: "", notes: "" },
          { id: "hg2t2", title: "تدريب المقيّمين", description: "تدريب المدراء على التقييم", owner: "وحدة التدريب", startDate: "2026-09-01", deadline: "2026-09-30", status: "in_progress", rating: "", notes: "" },
          { id: "hg2t3", title: "تنفيذ التقييم", description: "تقييم جميع الموظفين", owner: "المدراء", startDate: "2026-10-01", deadline: "2026-11-30", status: "not_started", rating: "", notes: "" },
          { id: "hg2t4", title: "تحليل النتائج", description: "تحليل وإعداد التقرير", owner: "مدير الموارد البشرية", startDate: "2026-12-01", deadline: "2026-12-31", status: "not_started", rating: "", notes: "" },
        ],
      },
      {
        id: "hg3", name: "تحديث لوائح الموارد البشرية",
        description: "مراجعة وتحديث لوائح الموارد البشرية",
        owner: "مدير الموارد البشرية", priority: "medium",
        startDate: "2026-04-01", endDate: "2026-11-30",
        weight: 25, budget: 45000,
        indicators: "عدد اللوائح المحدّثة\nنسبة الالتزام",
        tasks: [
          { id: "hg3t1", title: "مراجعة الحالية", description: "مراجعة شاملة للوائح", owner: "مدير الموارد البشرية", startDate: "2026-04-01", deadline: "2026-05-31", status: "completed", rating: "", notes: "" },
          { id: "hg3t2", title: "مقارنة معيارية", description: "مقارنة مع أفضل الممارسات", owner: "استشاري خارجي", startDate: "2026-06-01", deadline: "2026-07-31", status: "in_progress", rating: "", notes: "" },
          { id: "hg3t3", title: "تحديث", description: "كتابة اللوائح المحدّثة", owner: "مدير الموارد البشرية", startDate: "2026-08-01", deadline: "2026-10-31", status: "in_progress", rating: "", notes: "" },
          { id: "hg3t4", title: "اعتماد", description: "اعتماد المجلس", owner: "المدير التنفيذي", startDate: "2026-11-01", deadline: "2026-11-30", status: "not_started", rating: "", notes: "" },
        ],
      },
    ],
  },
  communications: {
    name: "الاتصال المؤسسي",
    goals: [
      {
        id: "cmg1", name: "زيادة المتابعين 50%",
        description: "نمو متابعي السوشيال ميديا بنسبة 50%",
        owner: "مدير الاتصال", priority: "high",
        startDate: "2026-01-01", endDate: "2026-12-31",
        weight: 40, budget: 220000,
        indicators: "عدد المتابعين الجدد\nمعدل التفاعل\nالوصول",
        tasks: [
          { id: "cmg1t1", title: "خطة محتوى", description: "خطة محتوى سنوية تفصيلية", owner: "مدير المحتوى", startDate: "2026-01-15", deadline: "2026-02-28", status: "completed", rating: "ممتاز", notes: "" },
          { id: "cmg1t2", title: "حملات مدفوعة", description: "حملات إعلانية شهرية", owner: "مدير التسويق", startDate: "2026-03-01", deadline: "2026-12-31", status: "in_progress", rating: "", notes: "" },
          { id: "cmg1t3", title: "تعاون مع مؤثرين", description: "شراكة مع 5 مؤثرين", owner: "مدير العلاقات", startDate: "2026-04-01", deadline: "2026-08-31", status: "completed", rating: "جيد", notes: "" },
          { id: "cmg1t4", title: "تحليل أسبوعي", description: "تحليلات أداء أسبوعية", owner: "محلل البيانات", startDate: "2026-03-01", deadline: "2026-12-31", status: "in_progress", rating: "", notes: "" },
        ],
      },
      {
        id: "cmg2", name: "12 تغطية إعلامية سنوياً",
        description: "تحقيق 12 تغطية في الإعلام الرسمي",
        owner: "مدير العلاقات", priority: "medium",
        startDate: "2026-01-01", endDate: "2026-12-31",
        weight: 30, budget: 80000,
        indicators: "عدد التغطيات\nمدى الانتشار",
        tasks: [
          { id: "cmg2t1", title: "قائمة وسائل", description: "قائمة 20 وسيلة إعلامية", owner: "مدير العلاقات", startDate: "2026-01-15", deadline: "2026-02-28", status: "completed", rating: "", notes: "" },
          { id: "cmg2t2", title: "بيانات صحفية", description: "إصدار بيان شهري", owner: "كاتبة محتوى", startDate: "2026-03-01", deadline: "2026-12-31", status: "in_progress", rating: "", notes: "" },
          { id: "cmg2t3", title: "دعوات", description: "دعوة الإعلاميين للفعاليات", owner: "مدير العلاقات", startDate: "2026-04-01", deadline: "2026-12-31", status: "in_progress", rating: "", notes: "" },
          { id: "cmg2t4", title: "متابعة", description: "متابعة النشر والتفاعل", owner: "وحدة الرصد", startDate: "2026-03-01", deadline: "2026-12-31", status: "in_progress", rating: "", notes: "" },
        ],
      },
      {
        id: "cmg3", name: "إنتاج 6 أفلام وثائقية",
        description: "إنتاج 6 أفلام وثائقية عن أعمال الجمعية",
        owner: "مدير الإنتاج", priority: "medium",
        startDate: "2026-01-01", endDate: "2026-12-31",
        weight: 30, budget: 480000,
        indicators: "عدد الأفلام\nالمشاهدات\nمعدل التفاعل",
        tasks: [
          { id: "cmg3t1", title: "كتابة السيناريو", description: "سيناريوهات 6 أفلام", owner: "كاتب سيناريو", startDate: "2026-01-15", deadline: "2026-05-31", status: "completed", rating: "ممتاز", notes: "" },
          { id: "cmg3t2", title: "تصوير", description: "تصوير 6 أفلام", owner: "مدير الإنتاج", startDate: "2026-04-01", deadline: "2026-10-31", status: "in_progress", rating: "", notes: "" },
          { id: "cmg3t3", title: "مونتاج", description: "مونتاج 6 أفلام", owner: "مونتير", startDate: "2026-06-01", deadline: "2026-11-30", status: "in_progress", rating: "", notes: "" },
          { id: "cmg3t4", title: "نشر", description: "نشر على القنوات", owner: "مدير المحتوى", startDate: "2026-07-01", deadline: "2026-12-31", status: "in_progress", rating: "", notes: "" },
        ],
      },
    ],
  },
  volunteer: {
    name: "التطوع",
    goals: [
      {
        id: "vg1", name: "استقطاب 100 متطوع جديد",
        description: "استقطاب وتسجيل 100 متطوع جديد",
        owner: "مدير التطوع", priority: "high",
        startDate: "2026-01-01", endDate: "2026-12-31",
        weight: 40, budget: 80000,
        indicators: "عدد المتطوعين الجدد\nمصادر الاستقطاب\nنسبة الاحتفاظ",
        tasks: [
          { id: "vg1t1", title: "حملة استقطاب", description: "حملة سوشيال ميديا", owner: "مدير التسويق", startDate: "2026-02-01", deadline: "2026-05-31", status: "completed", rating: "جيد", notes: "" },
          { id: "vg1t2", title: "معرض تطوع", description: "تنظيم معرض تطوع سنوي", owner: "مدير الفعاليات", startDate: "2026-04-01", deadline: "2026-05-31", status: "completed", rating: "ممتاز", notes: "" },
          { id: "vg1t3", title: "شراكة مع جامعات", description: "شراكة مع 5 جامعات", owner: "منسق العلاقات", startDate: "2026-03-01", deadline: "2026-09-30", status: "in_progress", rating: "", notes: "" },
          { id: "vg1t4", title: "تسجيل إلكتروني", description: "بوابة تسجيل المتطوعين", owner: "مدير النظام", startDate: "2026-02-01", deadline: "2026-04-30", status: "completed", rating: "", notes: "" },
        ],
      },
      {
        id: "vg2", name: "تحقيق 10,000 ساعة تطوع",
        description: "تحقيق 10K ساعة تطوع خلال العام",
        owner: "مدير التطوع", priority: "high",
        startDate: "2026-01-01", endDate: "2026-12-31",
        weight: 35, budget: 60000,
        indicators: "إجمالي الساعات\nمتوسط الساعات لكل متطوع",
        tasks: [
          { id: "vg2t1", title: "جدولة الفعاليات", description: "12 فعالية تطوعية", owner: "منسق التطوع", startDate: "2026-01-01", deadline: "2026-12-31", status: "in_progress", rating: "", notes: "" },
          { id: "vg2t2", title: "تتبع الساعات", description: "نظام تتبع إلكتروني للساعات", owner: "مدير النظام", startDate: "2026-02-01", deadline: "2026-06-30", status: "completed", rating: "", notes: "" },
          { id: "vg2t3", title: "حوافز", description: "برنامج حوافز للمتميزين", owner: "مدير التطوع", startDate: "2026-04-01", deadline: "2026-12-31", status: "in_progress", rating: "", notes: "" },
          { id: "vg2t4", title: "تقارير", description: "تقارير شهرية بالساعات", owner: "محلل البيانات", startDate: "2026-03-01", deadline: "2026-12-31", status: "in_progress", rating: "", notes: "" },
        ],
      },
      {
        id: "vg3", name: "تدريب قيادات تطوعية",
        description: "بناء كوادر قيادية من المتطوعين",
        owner: "وحدة التدريب", priority: "medium",
        startDate: "2026-01-01", endDate: "2026-10-31",
        weight: 25, budget: 70000,
        indicators: "عدد القيادات المدربة\nمعدل التطبيق\nرضا المتطوعين",
        tasks: [
          { id: "vg3t1", title: "تحديد المرشحين", description: "اختيار 15 مرشح", owner: "مدير التطوع", startDate: "2026-01-15", deadline: "2026-03-31", status: "completed", rating: "", notes: "" },
          { id: "vg3t2", title: "برنامج تدريبي", description: "برنامج 80 ساعة", owner: "وحدة التدريب", startDate: "2026-04-01", deadline: "2026-08-31", status: "in_progress", rating: "", notes: "" },
          { id: "vg3t3", title: "تطبيق عملي", description: "قيادة فرق فعلية", owner: "مدير التطوع", startDate: "2026-07-01", deadline: "2026-10-31", status: "in_progress", rating: "", notes: "" },
          { id: "vg3t4", title: "تقييم", description: "تقييم نهائي للقيادات", owner: "وحدة التقييم", startDate: "2026-10-01", deadline: "2026-10-31", status: "not_started", rating: "", notes: "" },
        ],
      },
    ],
  },
  governance: {
    name: "الحوكمة",
    goals: [
      {
        id: "gvg1", name: "رفع درجة الحوكمة لـ 95%",
        description: "تحقيق درجة حوكمة 95% وفق المعايير الوطنية",
        owner: "أمين السر", priority: "high",
        startDate: "2026-01-01", endDate: "2026-12-31",
        weight: 40, budget: 120000,
        indicators: "درجة الحوكمة\nعدد الفجوات المغلقة\nنتائج التدقيق",
        tasks: [
          { id: "gvg1t1", title: "مراجعة الفجوات", description: "تحليل فجوات الحوكمة", owner: "اللجنة القانونية", startDate: "2026-01-15", deadline: "2026-03-31", status: "completed", rating: "", notes: "" },
          { id: "gvg1t2", title: "خطة إصلاح", description: "وضع خطة لمعالجة الفجوات", owner: "أمين السر", startDate: "2026-04-01", deadline: "2026-05-31", status: "completed", rating: "جيد", notes: "" },
          { id: "gvg1t3", title: "تنفيذ", description: "تنفيذ خطة الإصلاح", owner: "اللجان المختصة", startDate: "2026-06-01", deadline: "2026-10-31", status: "in_progress", rating: "", notes: "" },
          { id: "gvg1t4", title: "تقييم خارجي", description: "تقييم من جهة محايدة", owner: "مدقق خارجي", startDate: "2026-11-01", deadline: "2026-12-31", status: "not_started", rating: "", notes: "" },
        ],
      },
      {
        id: "gvg2", name: "تحديث كل اللوائح",
        description: "حصر وتحديث جميع لوائح الجمعية",
        owner: "اللجنة القانونية", priority: "high",
        startDate: "2026-01-01", endDate: "2026-11-30",
        weight: 30, budget: 80000,
        indicators: "عدد اللوائح المحدّثة\nنسبة الاكتمال",
        tasks: [
          { id: "gvg2t1", title: "حصر اللوائح", description: "حصر شامل للوائح الحالية", owner: "أمين السر", startDate: "2026-01-15", deadline: "2026-02-28", status: "completed", rating: "", notes: "" },
          { id: "gvg2t2", title: "مراجعة قانونية", description: "مراجعة من مستشار قانوني", owner: "مستشار قانوني", startDate: "2026-03-01", deadline: "2026-06-30", status: "in_progress", rating: "", notes: "" },
          { id: "gvg2t3", title: "تحديث", description: "كتابة اللوائح المحدّثة", owner: "اللجنة القانونية", startDate: "2026-07-01", deadline: "2026-10-31", status: "in_progress", rating: "", notes: "" },
          { id: "gvg2t4", title: "اعتماد المجلس", description: "اعتماد من المجلس", owner: "رئيس المجلس", startDate: "2026-11-01", deadline: "2026-11-30", status: "not_started", rating: "", notes: "" },
        ],
      },
      {
        id: "gvg3", name: "تطبيق نظام إدارة المخاطر",
        description: "بناء نظام متكامل لإدارة المخاطر",
        owner: "مدير المخاطر", priority: "high",
        startDate: "2026-01-01", endDate: "2026-12-31",
        weight: 30, budget: 95000,
        indicators: "عدد المخاطر المحددة\nعدد الخطط النشطة",
        tasks: [
          { id: "gvg3t1", title: "تحديد المخاطر", description: "حصر شامل للمخاطر", owner: "لجنة المخاطر", startDate: "2026-02-01", deadline: "2026-04-30", status: "completed", rating: "ممتاز", notes: "" },
          { id: "gvg3t2", title: "تقييم", description: "تقييم الأثر والاحتمال", owner: "مدير المخاطر", startDate: "2026-05-01", deadline: "2026-06-30", status: "completed", rating: "", notes: "" },
          { id: "gvg3t3", title: "خطط معالجة", description: "خطة لكل خطر حرج/مرتفع", owner: "لجنة المخاطر", startDate: "2026-07-01", deadline: "2026-10-31", status: "in_progress", rating: "", notes: "" },
          { id: "gvg3t4", title: "مراقبة دورية", description: "متابعة شهرية للمخاطر", owner: "مدير المخاطر", startDate: "2026-08-01", deadline: "2026-12-31", status: "in_progress", rating: "", notes: "" },
        ],
      },
    ],
  },
};

// ===== قوالب الألوان =====
export const COLOR_TEMPLATES = [
  { name: "أزرق كلاسيكي", primary: "#003d58", secondary: "#e8f4fd" },
  { name: "ذهبي ملكي", primary: "#8B6914", secondary: "#FFF8E1" },
  { name: "أخضر إسلامي", primary: "#1B5E20", secondary: "#E8F5E9" },
  { name: "فيروزي عصري", primary: "#00695C", secondary: "#E0F2F1" },
  { name: "بنفسجي أنيق", primary: "#4A148C", secondary: "#F3E5F5" },
  { name: "برتقالي دافئ", primary: "#E65100", secondary: "#FFF3E0" },
  { name: "أحمر جريء", primary: "#B71C1C", secondary: "#FFEBEE" },
  { name: "رمادي حديث", primary: "#37474F", secondary: "#ECEFF1" },
  { name: "وردي ناعم", primary: "#880E4F", secondary: "#FCE4EC" },
  { name: "نيلي عميق", primary: "#1A237E", secondary: "#E8EAF6" },
  { name: "بني ترابي", primary: "#4E342E", secondary: "#EFEBE9" },
  { name: "سماوي صافي", primary: "#0277BD", secondary: "#E1F5FE" },
  { name: "زيتي كلاسيكي", primary: "#33691E", secondary: "#F1F8E9" },
  { name: "عنابي فاخر", primary: "#6A1B29", secondary: "#FDE8EF" },
  { name: "كحلي رسمي", primary: "#0D253F", secondary: "#E3EDF7" },
];

// ===== قائمة المشايخ =====
export const SHEIKHS = [
  { id: 1, name: "الشيخ عبدالله المحمد" },
  { id: 2, name: "الشيخ صالح العبدالله" },
  { id: 3, name: "الشيخ محمد الصالح" },
  { id: 4, name: "الشيخ إبراهيم العمر" },
  { id: 5, name: "الشيخ خالد السعيد" },
  { id: 6, name: "الشيخ أحمد الراشد" },
  { id: 7, name: "الشيخ عبدالرحمن الفهد" },
  { id: 8, name: "الشيخ سعد الدوسري" },
  { id: 9, name: "الشيخ فهد القحطاني" },
  { id: 10, name: "الشيخ يوسف الغامدي" },
  { id: 11, name: "الشيخ عمر المطيري" },
  { id: 12, name: "الشيخ ناصر الحربي" },
  { id: 13, name: "الشيخ بندر الشمري" },
  { id: 14, name: "الشيخ تركي العتيبي" },
  { id: 15, name: "الشيخ مشاري السبيعي" },
  { id: 16, name: "الشيخ حمد الزهراني" },
  { id: 17, name: "الشيخ ماجد البلوي" },
  { id: 18, name: "الشيخ وليد الجهني" },
];

// ===== الجنسيات =====
export const NATIONALITIES = [
  "فلبيني", "هندي", "بنغلاديشي", "باكستاني", "إندونيسي",
  "نيبالي", "سريلانكي", "إثيوبي", "إريتري", "نيجيري",
  "غاني", "كيني", "أوغندي", "تنزاني", "مالي",
  "سنغالي", "بورمي", "صيني", "تايلاندي", "فيتنامي",
];
